import request from '@/api/config/request'

const prex = "api/nota_avulsa";

export function gerarNotaAvulsa(data) {
    return request({
        url: `${prex}/gerar`,
        method: 'post',
        data
    })
}
